import {
  Organization as Org,
  Venue as OrgVenue,
  Store as OrgStore,
  Device as OrgDevice,
} from '@oolio-group/domain';

export type Organization = Pick<Org, 'id' | 'name'>;

export type Venue = Pick<OrgVenue, 'id' | 'name' | 'stores'>;
export type Store = Pick<OrgStore, 'id' | 'name'> & {
  isDeleted?: boolean;
};
export type Device = Pick<
  OrgDevice,
  'id' | 'name' | 'mode' | 'uuid' | 'isPaired'
>;

export type DeviceWithConfig = Pick<
  OrgDevice,
  'id' | 'name' | 'mode' | 'uuid' | 'isPaired' | 'config'
>;

// App Screen Types
export const AppScreen = {
  LANDING: '/landing', // QR code for device pairing
  GET_STARTED: '/onboarding', // Organization and venue selection
  DASHBOARD: '/', // Main application
  SETTINGS: '/settings', // App configuration
} as const;

export type AppScreen = (typeof AppScreen)[keyof typeof AppScreen];

// Storage Keys
export interface StorageKeys {
  USER_SESSION: 'orb_user_session';
  REFRESH_TOKEN: 'orb_refresh_token';
  SELECTED_ORGANIZATION: 'orb_selected_organization';
  SELECTED_VENUE: 'orb_selected_venue';
  SELECTED_STORE: 'orb_selected_store';
  AUTH_TOKENS: 'orb_auth_tokens';
  FINGERPRINT_UUID: 'orb_fingerprint_uuid';
}

export interface SessionState {
  isAuthenticated: boolean;
  hasOrganization: boolean;
  hasStore: boolean;
}
